import { useCallback, useEffect, useState } from 'react';
import clsx from 'clsx';

type ShufflingJobTextProps = {
  names: string[];
  className?: string;
};

export const ShufflingJobText = ({ names = [], className }: ShufflingJobTextProps) => {
  const getRandomMessage = useCallback(() => {
    const name = names[Math.floor(Math.random() * names.length)];
    return [
      `${name} is checking the job board...`,
      `${name} is networking with other kitties...`,
      `${name} found a lead on some catnip delivery work...`,
      `${name} is updating their resume...`,
      `${name} is sweet-talking the hiring manager...`,
      `${name} is practicing their interview meows...`,
      `${name} is asking around the neighborhood...`,
      `${name} is scrolling through LinkedIn (KittyIn?)...`,
      `${name} is calling in favors from old friends...`,
      `${name} is polishing their fish-catching skills...`,
      `${name} is checking the classifieds...`,
      `${name} is leveraging her royal connections...`,
      `${name} is hitting up the local yarn shops...`,
      `${name} is consulting her ancient job-hunting scrolls...`,
      `${name} is making deals in dark alleys...`,
      `${name} is charming her way into opportunities...`,
      `${name} is digging through trash for job leads...`,
      `${name} is using her stealth skills for reconnaissance...`,
      `${name} is purring his way into interviews...`,
      `${name} is hunting down the perfect gig...`,
      `${name} is attending a virtual job fair from her cardboard box...`,
      `${name} is perfecting her elevator pitch (literally, in an elevator)...`,
      `${name} is researching companies while napping on keyboards...`,
      `${name} is building her professional network at the local fish market...`,
      `${name} is tailoring her cover letter with actual thread...`,
      `${name} is practicing firm pawshakes...`,
      `${name} is studying salary negotiation tactics...`,
      `${name} is optimizing her CatCV for ATS systems...`,
      `${name} is cold-calling potential employers (literally cold, it's winter)...`,
      `${name} is attending networking events at the pet store...`,
      `${name} is following up on applications with persistent meowing...`,
      `${name} is researching company culture through window surveillance...`,
      `${name} is preparing for behavioral interview questions...`,
      `${name} is building her portfolio of knocked-over items...`,
      `${name} is seeking mentorship from senior office cats...`,
      `${name} is exploring remote work opportunities from sunny windowsills...`,
      `${name} is updating her professional headshots (glamour shots)...`,
      `${name} is practicing typing skills by walking across keyboards...`,
      `${name} is attending career development workshops at the library...`,
      `${name} is leveraging social media for job hunting (CatTok?)...`,
      `${name} is preparing references from satisfied mouse-catching clients...`,
      `${name} is researching industry trends in the latest trade publications...`,
      `${name} is networking at professional associations (Cats in Business)...`,
      `${name} is fine-tuning her personal brand as a reliable mouser...`,
      `${name} is exploring freelance opportunities in pest control...`,
      `${name} is attending job search support groups...`,
      `${name} is practicing interview questions in front of the mirror...`,
      `${name} is researching potential employers' treat policies...`,
      `${name} is building connections through volunteer work at animal shelters...`,
      `${name} is exploring career pivots into the growing catnip industry...`,
      `${name} is attending virtual coffee chats (with actual coffee)...`
    ].sort(() => Math.random() - 0.5)[0];
  }, [names]);

  const [currentMessage, setCurrentMessage] = useState(getRandomMessage());

  useEffect(() => {
    const interval = setInterval(() => {
      const newMessage = getRandomMessage();
      setCurrentMessage(newMessage);
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
    <div className="text-center">
      <p className={clsx("text-sm text-gray-500 italic", className)}>
        {currentMessage}
      </p>
    </div>
  );
};